// Public presentation assets only. STEP/STL manufacturing sources remain in
// the private project; these render meshes have no device/control connection.
export const hardwareProducts = Object.freeze({
  aeroponic: Object.freeze({
    name: "FEEDER Aeroponic", label: "FEEDER / AEROPONIC", revision: "Rev31 · Gehäuse v14",
    url: "/feeder-assets/hardware-20261026/aeroponic-display-enclosure.glb",
    poster: "/feeder-assets/hardware-20261026/aeroponic-display-enclosure.webp",
    displaySurfaceName: "display_original_screenshot",
    // Installed upright: PG12 cable glands below the display, not above it.
    rotation: [-Math.PI / 2, Math.PI, 0], camera: [.8, .9, 2.6], openCamera: [.8, 1.1, -2.6],
    movingParts: {
      shell_front: [0, -.07, 0],
      chassis: [0, -.035, 0],
      service_back: [.22, .055, -.025],
      wall_bracket: [-.22, .075, -.025],
    },
    boardGroups: ["board_main", "board_daughter"],
  }),
  chaac: Object.freeze({
    name: "Chaac", label: "FEEDER / CHAAC", revision: "Aktueller Gehäusestand",
    url: "/feeder-assets/hardware-20261026/chaac-enclosure.glb",
    poster: "/feeder-assets/hardware-20261026/chaac-enclosure.webp",
    rotation: [Math.PI / 2, Math.PI / 2, 0], camera: [.65, .9, 2.7], openCamera: [.65, 2.7, 1.7],
    movingParts: { top_shell: [0, .045, 0], bottom_shell: [0, -.012, 0] },
    boardGroups: ["board"],
  }),
})
